module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-onlineaccoutopenning-bg.c8d2ee4d.png";